export default "__VITE_ASSET__D1FIx2e4__"